module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step2-FR.98af900c.png";